var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphbarblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14285 2.09521V17.3605C3.14285 18.0353 3.38813 18.6824 3.82472 19.1596C4.26131 19.6367 4.85346 19.9047 5.4709 19.9047H18.8571M6.63492 12.2721V16.0884M11.291 8.45576V16.0884M15.9471 4.63943V16.0884",
    stroke: "#8276F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphbarblue);
export default __webpack_public_path__ + "static/media/graphbarblue.590a6b04ad63bacb2fd00f6a868c923f.svg";
export { ForwardRef as ReactComponent };